(function () {
  'use strict';

  angular.module('ringbaPortal').component('ivr', {
    controller: IvrController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/ivr/ivr.view.html'
  });

  function IvrController(
    $q,
    $filter,
    $scope,
    $state,
    $stateParams,
    $timeout,
    $transitions,
    accountsService,
    userSettingsService,
    ivrService,
    randomcolor,
    toaster
  ) {
    'ngInject';

    const vm = this;

    vm.collapseAll = {
      isCollapsed: false
    };

    vm.$onInit = onInit;
    vm.logEvent = _logEvent;
    vm.dragStartEvent = _dragStartEvent.bind(vm);
    vm.dragStopEvent = _dragStopEvent.bind(vm);
    vm.destroyMirrorEvent = _destroyMirrorEvent.bind(vm);
    vm.onAddNodeToTree = onAddNodeToTree;
    vm.updateLink = updateLink;
    vm.onRemoveNode = onRemoveNode;
    vm.onSaveTree = onSaveTree;
    vm.onUpdateNode = onUpdateNode;
    vm.updateConnections = _updateConnections;
    vm.nameChange = nameChange;
    vm.collapseAllNodes = collapseAllNodes;
    vm.activateSelectMode = activateSelectMode;
    vm.selectGotoDestinationNode = selectGotoDestinationNode;
    vm.deactivateSelectMode = deactivateSelectMode;
    vm.scrollHighlightNode = scrollHighlightNode;
    vm.uploadAudioFile = uploadAudioFile;
    vm.hideTemplatePopover = hideTemplatePopover;
    vm.dontShowAgainTemplatePopover = dontShowAgainTemplatePopover;

    function onInit() {
      _setListenerForStateChangeOrRefresh();
      vm.loading = true;
      vm.widgetTitle = !$stateParams.treeId ? 'Create IVR Tree' : 'Edit IVR Tree';
      let ivrTree;
      if ($stateParams.treeId) {
        ivrTree = ivrService.getTree(accountsService.currentAccountId, $stateParams.treeId);
      } else if ($stateParams.templateId) {
        _showTemplatePopover();
        ivrTree = ivrService.createTemplate(accountsService.currentAccountId, $stateParams.templateId, 'Template: ' + $stateParams.templateId);
      } else {
        ivrTree = ivrService.createTree(accountsService.currentAccountId, 'New IVR');
      }
      _redrawTree(ivrTree, true);

      vm.treeUpdates = 0;

      vm.draggableOptions = {
        draggable: '.node-type.draggable',
        dropzone: '.node-palette, .dropzone',
        appendTo: 'ivr',
        classes: {},
        events: {
          'drag:start': vm.dragStartEvent,
          'drag:move': _dragMoveEvent,
          'drag:over': vm.logEvent,
          'drag:over:container': vm.logEvent,
          'drag:out': vm.logEvent,
          'drag:out:container': vm.logEvent,
          'drag:stop': vm.dragStopEvent,
          'drag:pressure': vm.logEvent,
          'droppable:dropped': vm.logEvent,
          'droppable:returned': vm.logEvent,
          'mirror:created': vm.logEvent,
          'mirror:destroy': vm.destroyMirrorEvent,
          'mirror:attached': vm.logEvent,
          'mirror:move': vm.logEvent
        }
      };
    }

    function onAddNodeToTree(parentNodeId, nodeTypeId, name, onSuccess, criteria, callback) {
      _redrawTree(ivrService.attachNode(accountsService.currentAccountId, vm._tree, parentNodeId, vm.nodeTypeLookup[nodeTypeId], name, onSuccess, criteria), true, callback);
    }

    function onRemoveNode(node) {
      _redrawTree(ivrService.removeNode(accountsService.currentAccountId, vm._tree, node.id, node.parentId, node.onSuccess, node.criteria), true);
    }

    function onUpdateNode(node) {
      _redrawTree(ivrService.updateNode(accountsService.currentAccountId, vm._tree, node), true);
    }

    function onSaveTree() {
      if ($stateParams.treeId) {
        _redrawTree(ivrService.commitTree(accountsService.currentAccountId, vm._tree), false, function () {
          vm.isDirty = false;
        });
      }
      else {
        ivrService.commitTree(accountsService.currentAccountId, vm._tree)
          .then(function (data) {
            if (data.success) {
              vm.isDirty = false;
              $state.go('dashboard.ivr.new', {
                treeId: vm._tree.id
              });
              vm.widgetTitle = 'Edit IVR Tree';
            } else {
              _redrawTree($q.when(data));
            }
          });
      }
    }

    function collapseAllNodes(collapse) {
      vm.collapseAll = {
        isCollapsed: collapse
      };
      _updateConnections();
    }

    function activateSelectMode(gotoNodeId) {
      vm.nodeIdOfSourceGotoNode = gotoNodeId;
      vm.isSelectModeActive = true;
    }

    function selectGotoDestinationNode(destinationNodeId) {
      const gotoSourceNode = vm._tree.nodes[vm.nodeIdOfSourceGotoNode].node;
      gotoSourceNode.settings['goToNodeId'] = destinationNodeId;
      onUpdateNode(gotoSourceNode);
      scrollHighlightNode(vm.nodeIdOfSourceGotoNode);
      deactivateSelectMode();
    }

    function deactivateSelectMode() {
      vm.nodeIdOfSourceGotoNode = null;
      vm.isSelectModeActive = false;
    }

    function hideTemplatePopover() {
      vm.showTemplatePopover = false;
    }

    function dontShowAgainTemplatePopover() {
      vm.showTemplatePopover = false;
      vm.userSettings.showTemplatePopover = false;
      userSettingsService.saveUserSettings(vm.userSettings);
    }

    function _redrawTree(promise, treeUpdated, callback) {
      let drawConnections = _updateConnections;
      if (treeUpdated) {
        vm.isDirty = true;
        vm.treeUpdates = vm.treeUpdates + 1;
        drawConnections = _displayConnections;
      }
      const _callback = callback ? callback : $q.when();
      const getNodeTypesPromise = vm.nodeTypeLookup ? $q.when(vm.nodeTypeLookup) : _initAvailableNodeTypes();
      const getIvrFiles = _initIvrFiles();
      return $q.all([getNodeTypesPromise, getIvrFiles, promise.then(_transformTreeForView)]).then(_initTreeCanvas).then(drawConnections).then(_callback);
    }

    function _logEvent(ev) {
      console.log(ev.constructor.name); // eslint-disable-line no-console
    }

    function _dragStartEvent(ev) {
      if ($(ev.sourceContainer).find('.tree-canvas.empty').length && ivrService.isGotoNode(ev.source.dataset.nodeTypeId)) {
        ev.cancel();
        _showToaster($filter('translate')('IVR_GOTO_NODE_ROOT_ERROR_MESSAGE'));
        return;
      }
      this.originalSourceParent = ev.originalSource.parentNode;
      this.originalSourceNextSibling = ev.originalSource.nextElementSibling;
    }

    function _dragMoveEvent(ev) {
      ev.source.style.display = 'none';
      ev.originalSource.style.display = '';
    }

    function _dragStopEvent(ev) {
      ev.originalSource.style.display = '';
      // clone the source and attach to it's original position in the container
      if (this.originalSourceNextSibling) {
        this.originalSourceNextSibling.parentNode.insertBefore(ev.originalSource.cloneNode(true), this.originalSourceNextSibling);
      } else {
        this.originalSourceParent.appendChild(ev.originalSource.cloneNode(true));
      }

      // if not releasing into a dropzone then move the source to a fragment off the tree
      // to prevent draggable from attaching it back to the container
      if (ev.source.parentNode && !ev.source.parentNode.classList.contains('dropzone')) {
        const fragment = document.createDocumentFragment();
        ev.source.parentNode.removeChild(ev.source);
        fragment.appendChild(ev.source);
      } else if (ev.source.parentNode && ev.source.parentNode.classList.contains('dropzone')) {
        const dropTargetClassList = ev.source.parentNode.classList;
        const onSuccess = dropTargetClassList.contains('success');
        const parentNodeId = dropTargetClassList.contains('tree-canvas') && dropTargetClassList.contains('empty') ?
          'root' :
          $(ev.source.parentNode).closest('ivr-node').attr('data-node-id');
        const linkName = ev.source.parentNode.dataset.name;
        const nodeTypeId = ev.source.dataset.nodeTypeId;
        const criteria = JSON.parse(ev.source.parentNode.dataset.criteria || '[]');
        this.parentNode = ev.source.parentNode;
        vm.onAddNodeToTree(parentNodeId, nodeTypeId, linkName, onSuccess, criteria);
      }
      // TODO: The Add Route dropzone doesn't get re-rendered, and draggable library adds the class of the dropzone being already occupied
      $('.new-route-dropzone').removeClass('draggable-dropzone--occupied');
    }

    function updateLink(nodeId, parentNodeId, filterCriteria, index) {
      return _redrawTree(ivrService.updateLink(accountsService.currentAccountId, vm._tree, nodeId, parentNodeId, index, filterCriteria, true), true);
    }

    function uploadAudioFile(nodeId, audioFile) {
      return ivrService.uploadAudioFile(accountsService.currentAccountId, vm._tree, audioFile).then(function (uploadedAsset) {
        toaster.pop('success', $filter('translate')('IVR_UPLOAD_SUCCESS'));
        return uploadedAsset;
      });
    }

    function _destroyMirrorEvent() {
      // Use :not(.no-user-select) to avoid removing the added node from a filled dropzone
      // when trying to drop a node-type over a filled dropzone
      //var _parentNode = this.parentNode;
      const _removeMirror = function () {
        $(this.parentNode).find('.node-type:not(.no-user-select)').remove();
      };
      $timeout(_removeMirror.bind(this), 1);
    }

    function _initAvailableNodeTypes() {
      // Get node type for root - assume this returns all the possible node types
      return ivrService.getAvailableNodes(accountsService.currentAccountId, {}, 'root').then(function (nodes) {
        vm.nodeTypes = nodes;
        vm.nodeTypeLookup = {};
        for (let i = 0; i < nodes.length; i++) {
          nodes[i].iconCssClass = ivrService.getNodeTypeIcon(nodes[i].nodeTypeId);
          vm.nodeTypeLookup[nodes[i].nodeTypeId] = nodes[i];
        }
        return vm.nodeTypeLookup;
      });
    }

    function _initIvrFiles() {
      return ivrService.getAudioFiles(accountsService.currentAccountId).then(function(files){
        return vm.ivrFiles = files;
      });
    }

    function _transformTreeForView(data) {
      _markNewNodeAdded(data.tree, vm._tree, data.isRouterNodeLinkAdded);
      vm._tree = angular.copy(data.tree);
      vm.treeName = vm._tree.name;
      const output = [
        [vm._tree.root]
      ];
      vm.nodeConnections = [];
      const connectionDefaults = {
        anchors: ['Right', 'Left'],
        connector: ['Flowchart', { stub: 10 }],
        endpoint: ['Dot', { radius: 5 }],
        endpointStyle: { fill: '#efec2c' },
        paintStyle: { strokeWidth: 3, stroke: '#222529' },
        overlays: [['Arrow', { location: 1, width: 10, length: 10 }]]
      };

      vm.treeErrors = data.treeErrors ? angular.copy(data.treeErrors) : [];
      const nodeEndpointColors = randomcolor({seed: vm._tree.id, count: _.size(vm._tree.nodes) + 1});
      let nodeIndex = 0;
      _.forOwn(vm._tree.nodes, function(n) {
        n.node.linkEndpointColor = nodeEndpointColors[nodeIndex++];
      });

      // Mutating object we are looping, not generally recomended
      for (let level = 0; level < output.length; level++) {
        const nodesOnNthLevel = output[level];
        for (let nthNode = 0; nthNode < nodesOnNthLevel.length; nthNode++) {
          const nthNodeOnNthLevel = nodesOnNthLevel[nthNode];
          const isGotoNode = ivrService.isGotoNode(nthNodeOnNthLevel.nodeTypeId);
          const nthNodeChildLinks = nthNodeOnNthLevel.childLinks;
          for (let nthChild = 0; nthChild < nthNodeChildLinks.length; nthChild++) {
            if (isGotoNode && nthNodeChildLinks[nthChild].onSuccess) {
              continue;
            }
            const childLink = vm._tree.nodes[nthNodeChildLinks[nthChild].childNodeId];
            const childNode = childLink.node;
            childNode.id = nthNodeChildLinks[nthChild].childNodeId; // TODO: this is FD by PETE
            nthNodeChildLinks[nthChild].childNodeType = childNode.nodeTypeId;
            childNode.childLinks = childLink.childLinks;
            childNode.childLinksLookup = _.keyBy(childNode.childLinks, function (val) {
              val.label = vm._tree.nodes[val.childNodeId].node.stepName;
              return val.name;
            });


            if (data.nodeErrors && data.nodeErrors[childNode.id]) {
              childNode.error = data.nodeErrors[childNode.id];
            }
            output[level + 1] = output[level + 1] || [];
            output[level + 1].push(childNode);
            if (level > 0) {
              vm.nodeConnections.push($.extend({
                source: 'node-' + nthNodeOnNthLevel.id,
                target: '#node-' + childNode.id + ' .panel-heading'
              }, connectionDefaults, {
                endpointStyle: {
                  fill: nthNodeOnNthLevel.linkEndpointColor
                }
              }));
            }
          }
        }
      }
      output.shift(); // don't display root node
      return output;
    }

    function _markNewNodeAdded(newTree, oldTree, skipHighlightNode) {
      if (!oldTree || !newTree || !newTree.nodes) {
        return;
      }
      for (const nodeID in newTree.nodes) {
        if (!(oldTree.nodes && Object.hasOwn(oldTree.nodes, nodeID))) {
          newTree.nodes[nodeID].node['showNode'] = !skipHighlightNode;
          return nodeID;
        }
      }
    }

    function scrollHighlightNode(nodeId) {
      let node;
      ivrService.normalizeShowNodeIvrItems(vm.ivrItems);
      _.forEach(vm.ivrItems, function (treeLevel) {
        node = _.find(treeLevel, { id: nodeId });
        return !node;
      });
      node['showNode'] = true;
      vm.ivrItems = angular.copy(vm.ivrItems);
    }

    function _initTreeCanvas(data) {
      const types = data[0],
        tree = data[2];

      for (let i = 0; i < tree.length; i++) {
        for (let j = 0; j < tree[i].length; j++) {
          tree[i][j].nodeTemplate = types[tree[i][j].nodeTypeId];
        }
      }

      vm.ivrItems = tree;
      vm.loading = false;

      return tree;
    }

    function _displayConnections() {
      $timeout(function () {
        window.jsPlumb.deleteEveryEndpoint();
        window.jsPlumb.batch(function () {
          for (let i = 0; i < vm.nodeConnections.length; i++) {
            vm.nodeConnections[i].target = $(vm.nodeConnections[i].target);
            window.jsPlumb.connect(vm.nodeConnections[i]);
          }
        });
      }, 333);
    }

    function _updateConnections() {
      $timeout(function () {
        window.jsPlumb.repaintEverything();
      }, 50);
    }

    function nameChange() {
      vm._tree.name = vm.treeName;
      vm.isDirty = true;
      vm.treeUpdates = vm.treeUpdates + 1;
    }

    function _setListenerForStateChangeOrRefresh() {
      const killDirtyHandler = $transitions.onBefore({}, _confirmOnStateChange);
      window.addEventListener('beforeunload', _confirmOnRefresh);

      $scope.$on(
        '$destroy',
        function () {
          // TODO: Clean up jsPlumb and event listeners on destroy
          killDirtyHandler();
          window.removeEventListener('beforeunload', _confirmOnRefresh);
        }
      );
    }

    function _confirmOnRefresh(event) {
      if (_checkDirtyState()) {
        // We can't show a custom confirm message when page is refreshed or the tab is closed
        return event.returnValue = $filter('translate')('IVR_UNLOAD_CONFIRMATION');
      }
    }

    function _confirmOnStateChange() {
      if (_checkDirtyState()) {
        return confirm($filter('translate')('IVR_UNLOAD_CONFIRMATION'));
      }
    }

    function _checkDirtyState() {
      return vm.treeUpdates > 0 && vm.isDirty;
    }

    function _showToaster(message) {
      $timeout(function () {
        toaster.pop('error', message);
      }, 0);
    }

    function _showTemplatePopover() {
      userSettingsService.getUserSettings().then(function (userSettings) {
        vm.userSettings = userSettings;
        vm.showTemplatePopover = userSettings.showTemplatePopover === false ? userSettings.showTemplatePopover: true;
      });
    }
  }
})();
